import React from 'react';

class Error extends React.Component {
    render() {
        return (
            <p className="error flash">Cable length may not { (parseFloat(this.props.value) > parseFloat(this.props.maxLength)) ? 'exceed' : 'deceed' } { (parseFloat(this.props.value) > parseFloat(this.props.maxLength)) ? this.props.maxLength : this.props.minLength }m
                ({ (parseFloat(this.props.value) > parseFloat(this.props.maxLength)) ? (this.props.maxLength * 3.2808).toFixed(2) : (this.props.minLength * 3.2808).toFixed(2)}ft).
            </p>
        );
    }
}

export default Error;


// WEBPACK FOOTER //
// ./../../htdocs/neutrik-opticalcon_fe/src/components/Error.js